import React, { useState, useEffect, useCallback } from "react";
import SearchBar from "./SearchBar";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import SubButtonBar1 from "../../../components/Layout/ButtonBar/SubButtonBar1";
import SubButtonBar2 from "../../../components/Layout/ButtonBar/SubButtonBar2";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import useAuiGridMethods from "../../../hooks/AuiGrid/useAuiGridMethods";
import {
  createMasterColumnData,
  createDetailColumnData,
} from "./conlumnLayout";
import gridLayout from "./gridLayout";
import { useId } from "react-id-generator";
import { saveGridCheckData } from "../../../utils/validators";

let primaryParameters = {
  mastCd: "",
  cdNmKor: "",
  useYn: "",
};

let auiMasterGrid;
let auiDetailGrid;
const CodeMng = (props) => {
  const [masterGrid] = useId(1, "aui-grid-");
  const [detailGrid] = useId(1, "aui-grid-");

  auiMasterGrid = useAuiGridMethods(masterGrid);
  auiDetailGrid = useAuiGridMethods(detailGrid);
  //auiDetailGrid.setFixedColumnCount(2);

  //그리드 초기 설정
  useEffect(() => {
    auiMasterGrid.create(createMasterColumnData(), {
      ...defaultGridProps,
      editable: true,
    });
    auiDetailGrid.create(createDetailColumnData(), {
      ...defaultGridProps,
      editable: true,
    });
    auiMasterGrid.bind("cellClick", function (event) {
      searchDetailList(event.item.mastCd);
    });
    // hidden 컬럼 정의
    auiDetailGrid.hideColumnByDataField("mastCd");
    // 에디팅 시작 이벤트 바인딩
    auiMasterGrid.bind("cellEditBegin", function (event) {
      // 추가된 행 아이템들(배열)은 수정이 가능해야

      if (auiMasterGrid.isAddedById(event.item._$uid)) {
        return true;
      }
      // 마스터 그리드의 마스터코드 편집 불가능
      if (event.dataField === "mastCd") {
        return false;
      }
    });

    // 에디팅 시작 이벤트 바인딩
    auiDetailGrid.bind("cellEditBegin", function (event) {
      // 추가된 행 아이템들(배열)은 수정이 가능해야
      if (auiDetailGrid.isAddedById(event.item._$uid)) {
        return true;
      }
      // 디테일 그리드의 디테일코드 편집 불가능
      if (event.dataField === "detailCd") {
        return false;
      }
    });
  }, []);

  const [codeFieldValues, setcodeFieldValues] = useState({
    mastCd: "",
    cdNmKor: "",
  });
  //공통코드 검색 URL
  const SEARCH_MASTER_CODE_URL = "/common/code/searchMasterCode.do";
  //공통코드 저장 URL
  const SAVE_MASTER_CODE_URL = "/common/code/saveMasterCode.do";

  //공통세부코드 URL
  const SEARCH_DETAIL_CODE_URL = "/common/code/searchDetailCode.do";
  //공통세부코드 저장 URL
  const SAVE_DETAIL_CODE_URL = "/common/code/saveDetailCode.do";

  const [, fetchCodeData] = useAxiosWithAuthorization(
    {
      url: SEARCH_MASTER_CODE_URL,
    },
    { manual: true }
  );

  const [, fetchDetailCodeData] = useAxiosWithAuthorization(
    {
      url: SEARCH_DETAIL_CODE_URL,
    },
    { manual: true }
  );

  const handleMasterSearch = async () => {
    const {
      data: { data },
    } = await fetchCodeData({
      url: SEARCH_MASTER_CODE_URL,
      params: primaryParameters,
    });
    auiMasterGrid.setGridData(data);
  };

  const searchDetailList = async (mastCd) => {
    const {
      data: { data },
    } = await fetchDetailCodeData({
      url: SEARCH_DETAIL_CODE_URL,
      params: { mastCd: mastCd },
    });

    auiDetailGrid.setGridData(data);
  };

  const handleMasterNew = () => {
    const item = new Object();
    auiMasterGrid.addRow(item, "last");
  };
  const handleMasterDelete = async () => {
    auiMasterGrid.removeRow("selectedIndex");
  };
  const handleMasterSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      const addItems = auiMasterGrid.getAddedRowItems();
      const editItems = auiMasterGrid.getEditedRowItems();
      const removeItems = auiMasterGrid.getRemovedItems();

      let param = saveGridCheckData(addItems, editItems, removeItems);

      const {
        data: { data },
      } = await fetchCodeData({
        url: SAVE_MASTER_CODE_URL,
        data: param,
        method: "POST",
      });

      handleMasterSearch();
    }
  };

  const handleDetailNew = () => {
    const item = new Object();
    const items = auiMasterGrid.getSelectedItems();

    for (var i = 0; i < items.length; i++) {
      var rowItem = items[i];

      item.mastCd = rowItem.item.mastCd;
    }

    auiDetailGrid.addRow(item, "last");
  };
  const handleDetailDelete = async () => {
    auiDetailGrid.removeRow("selectedIndex");
  };
  const handleDetailSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      const addItems = auiDetailGrid.getAddedRowItems();
      const editItems = auiDetailGrid.getEditedRowItems();
      const removeItems = auiDetailGrid.getRemovedItems();

      let param = saveGridCheckData(addItems, editItems, removeItems);

      const {
        data: { data },
      } = await fetchCodeData({
        url: SAVE_DETAIL_CODE_URL,
        data: param,
        method: "POST",
      });
      const items = auiMasterGrid.getSelectedItems()[0];
      const item = items.item;
      searchDetailList(item.mastCd);
    }
  };

  const setSearchParameters = (values) => {
    primaryParameters = values;
  };

  const handleMasterExcel = useCallback(() => {
    auiMasterGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
    });
  });

  const handleDetailExcel = useCallback(() => {
    auiDetailGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 셍세코드 리스트",
    });
  });

  return (
    <>
      <div className="flexible_button_box">
        <div className="title">
          <h2>
            {props?.menuInfo?.menuNmKor}
            <button type="button" className="page_favorite">
              즐겨찾기
            </button>
          </h2>
        </div>
      </div>
      <SearchBar setSearchParameters={setSearchParameters} />

      <div className="flexible_contents_box2">
        <div className="databox" style={{ width: "100%", height: "100%" }}>
          <div className="scrollbox">
            <SubButtonBar1
              menuInfo={props.menuInfo}
              handleMasterSearch={handleMasterSearch}
              handleMasterNew={handleMasterNew}
              handleMasterDelete={handleMasterDelete}
              handleMasterSave={handleMasterSave}
              handleMasterExcel={handleMasterExcel}
            />
            <div style={{ width: "100%", height: "100%" }}>
              <div id={masterGrid} style={{ width: "100%", height: 600 }} />
            </div>
          </div>
        </div>
        <div className="databox">
          <div className="subdatabox">
            <SubButtonBar2
              menuInfo={props.menuInfo}
              handleMasterNew={handleDetailNew}
              handleMasterDelete={handleDetailDelete}
              handleMasterSave={handleDetailSave}
              handleMasterExcel={handleDetailExcel}
            />
            <div id={detailGrid} style={{ height: 600 }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(CodeMng);
